import { useMemo, useState } from "react";
import SelectCustom from "./SelectCustom";
import Input from "./Input";
import type { Etablissement } from "@prisma/client";
import { UserWithMyRooms } from "@api/src/types/user";

interface EtablissementOption {
  value: string;
  label: string;
}

const NoOptionsMessage = () => (
  <a
    className="block w-full text-left text-sm text-gray-600"
    href="mailto:henrileclair@hotmail.fr?subject=Nouveau lieu pour MedSpot.fr ?&body=Bonjour, serait-ce possible d'avoir MedSpot.fr pour le lieu suivant:"
  >
    Votre lieu d’exercice n’est apparemment toujours pas référencé chez Medspot ? <u>Cliquez ici</u> pour nous
    contacter, nous reviendrons vers vous au plus vite 🏃‍♂️‍➡️
  </a>
);

export default function SelectEtablissement({
  defaultValues,
  etablissements,
}: {
  defaultValues: UserWithMyRooms;
  etablissements: Array<Etablissement>;
}) {
  const etablissementsOptions: EtablissementOption[] = etablissements.map((etablissement) => ({
    value: etablissement.name,
    label: etablissement.name,
  }));

  const [value, setValue] = useState<EtablissementOption | null>(
    defaultValues?.etablissement
      ? {
          value: defaultValues.etablissement,
          label: defaultValues.etablissement,
        }
      : null
  );

  const hopitaux = useMemo(() => {
    const etablissement = etablissements.find((etablissement) => etablissement.name === value?.label);
    return (etablissement?.hopitaux ?? []).map((hopital: string) => ({
      value: hopital,
      label: hopital,
    }));
  }, [value, etablissements]);

  return (
    <>
      <Input
        label="CHU de référence"
        name="etablissement"
        defaultValue={"Lille"}
        type="text"
        required
        // className="pointer-events-none opacity-50"
      >
        <SelectCustom
          name="etablissement"
          options={etablissementsOptions}
          isSearchable={false}
          isMulti={false}
          value={value}
          onChange={setValue}
          instanceId="etablissement"
          // creatable
          classNamePrefix="etablissement"
          components={{ NoOptionsMessage }}
        />
        {!value && (
          <a
            className="mt-2 block w-full text-left text-sm text-gray-600"
            href="mailto:henrileclair@hotmail.fr?subject=Nouveau lieu pour MedSpot.fr ?&body=Bonjour, serait-ce possible d'avoir MedSpot.fr pour le lieu suivant:"
          >
            Votre lieu d’exercice n’est pas référencé chez Medspot ? <u>Cliquez ici</u> pour nous contacter, nous
            reviendrons vers vous au plus vite 🏃‍♂️‍➡️
          </a>
        )}
      </Input>
      {!!hopitaux?.length && (
        <Input
          label="Mon lieu d'exercice"
          name="hopital"
          type="text"
          required
          placeholder="PUPH, PH, CCA, AHU, Interne..."
        >
          <SelectCustom
            name="hopital"
            isSearchable={false}
            defaultValue={{ value: defaultValues?.hopital, label: defaultValues?.hopital }}
            options={hopitaux}
            isMulti={false}
            instanceId="hoptial"
            classNamePrefix="hoptial"
          />
        </Input>
      )}
    </>
  );
}
